import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import CardComponent, { StyledCard } from '../Card.component';
import { getRef } from '../../utils/ref';

interface DropdownPos {
  left: number;
  top: number;
}

export enum DropdownPosition {
  LEFT_TOP = 'left_top',
  LEFT_BOTTOM = 'left_bottom',
  RIGHT_TOP = 'right_top',
}

export enum DropdownDirection {
  TOP = 'top',
  BOTTOM = 'bottom',
}

export interface DropdownProps
  extends React.AllHTMLAttributes<HTMLDivElement>,
    getRef<any> {
  position?: DropdownPosition;
  direction?: DropdownDirection;
  width?: string;
}

export const StyledDropdown = styled.div<{
  pos: DropdownPos;
  customWidth?: string;
}>`
  position: absolute;
  left: ${props => props.pos.left}px;
  top: ${props => props.pos.top}px;
  display: flex;
  flex-direction: column;
  width: ${props => props.customWidth || '250px'};
  animation: ${({ theme }) => theme.animations.slide.modal} 0.2s ease-in-out
    forwards;

  ${StyledCard} {
    background: rgba(255, 255, 255, 0.75);
    backdrop-filter: blur(10px);
    padding: 0.25rem 0;
    box-shadow: 0 0.25rem 2rem 0.125rem rgba(0, 0, 0, 0.25);
  }
`;

const DropdownComponent = ({
  getRef,
  width,
  position = DropdownPosition.LEFT_TOP,
  direction = DropdownDirection.TOP,
  children,
}: DropdownProps) => {
  const curRef = useRef(null);
  const [pos, setPos] = useState<DropdownPos>({
    left: 0,
    top: 0,
  });

  useEffect(() => {
    const { left, top, width, height } = getRef.current.getBoundingClientRect();

    if (position === DropdownPosition.RIGHT_TOP) {
      setPos({
        // @ts-ignore
        left: left + width,
        top:
          top -
          5 -
          (direction === DropdownDirection.BOTTOM
            ? // @ts-ignore
              curRef.current.getBoundingClientRect().height - 15
            : 0),
      });
    }

    if (position === DropdownPosition.LEFT_BOTTOM) {
      setPos({
        // @ts-ignore
        left: left - curRef.current.getBoundingClientRect().width + width,
        top: top + height + 5,
      });
    }

    if (position === DropdownPosition.LEFT_TOP) {
      setPos({
        // @ts-ignore
        left: left - curRef.current.getBoundingClientRect().width - 15,
        top,
      });
    }
  }, [position, getRef.current, curRef.current]);

  return (
    <StyledDropdown customWidth={width} ref={curRef} pos={pos}>
      <CardComponent>{children}</CardComponent>
    </StyledDropdown>
  );
};

export default DropdownComponent;
